/**
 * @returns {*[]|*}
 */
function getUrlHashes () {
  if (typeof window === 'undefined' || !window.location?.hash) return []

  return window.location.hash
    .replace(/^#/, '')
    .split('&')
}

module.exports = { getUrlHashes }
